<template>
  <UApp>
    <RouterView v-slot="{ Component }">
      <Transition name="route-fade" mode="out-in" appear>
        <component :is="Component" />
      </Transition>
    </RouterView>
  </UApp>
</template>
